import { RelistingInterface } from 'components/domain/relisting/RelistingPresenter'
import { create } from 'zustand'

export interface RelistingStoreState {
  showRelistingsBanner: boolean
  setShowRelistingsBanner: (newShowRelistingsBanner: boolean) => void
  listOfCardsToRelist: RelistingInterface[]
  setListOfCardsToRelist: (newListOfCardsToRelist: RelistingInterface[]) => void
}

export const useRelistingStore = create<RelistingStoreState>()((set) => ({
  showRelistingsBanner: false,
  setShowRelistingsBanner: (newShowRelistingsBanner: boolean) =>
    set({
      showRelistingsBanner: newShowRelistingsBanner,
    }),
  listOfCardsToRelist: [],
  setListOfCardsToRelist: (newListOfCardsToRelist: RelistingInterface[]) =>
    set({ listOfCardsToRelist: newListOfCardsToRelist }),
}))
